import { Button, Typography } from '@mui/material';
import { useAssessmentsContent, useFormSubmission } from 'packages/workspace/modules/datastores/omnichannel/useChannelResources';
import type { HttpModel } from 'packages/workspace/modules/prelude/http/http';
import { FETCH_DASHBOARD_CONTENT } from 'packages/workspace/services/fetchers/fetch-dashboard-content';
import useSession from 'packages/workspace/services/store/session-store';
import React, { useRef } from 'react';
import { useQueryClient } from 'react-query';
import ButtonWithIcon from '../common/ButtonWithIcon';
import RJSForm from '../rjsf-custom-widgets/RJSForm';
import type { ISubmitEvent } from '@rjsf/core';

export interface IAddPendingTaskProps {
  document_id: string;
  onClose: () => void;
  isDrawerOpen: Record<string, unknown>;
}

const AddPendingTask: React.FC<IAddPendingTaskProps> = (props) => {
  const session = useSession();
  const submitFormRef = useRef<HTMLButtonElement>(null);
  const queryClient = useQueryClient();
  const { data, isSuccess } = useAssessmentsContent(props.isDrawerOpen.id as string);
  const formSubmissionMutation = useFormSubmission();

  const onFormSubmit = ({ formData }: ISubmitEvent<Record<string, unknown>>) => {
    const updatedFormData = {
      id: '',
      form_id: props.isDrawerOpen.id,
      display_name: session?.iamPrincipal?.displayName + props.isDrawerOpen.name,
      tags: [],
      submission: {
        formData,
      },
      last_submitted_at: '',
      completed_at: '',
      complete_request: true,
    };

    formSubmissionMutation.mutate(updatedFormData as unknown as HttpModel.IRequestPayload, {
      onSuccess() {
        queryClient.invalidateQueries(FETCH_DASHBOARD_CONTENT);
        props.onClose();
      },
    });
  };

  const onSaveClick = () => {
    submitFormRef.current?.click();
  };

  return (
    <>
      <div className="rhs-drawer-content">
        <div className="drawer-inner-container">
          <div className="drawer-header">
            <Typography variant="subtitle2" className="title">
              {props.isDrawerOpen.name as string}
            </Typography>
            <ButtonWithIcon onClick={props.onClose} />
          </div>
          <div className="px-5 bucket-form-container">
            {isSuccess && data?.fields && (
              <RJSForm schema={data.fields} uiSchema={data.field_specs} onSubmit={onFormSubmit} noHtml5Validate showErrorList={false}>
                <button ref={submitFormRef} type="submit" style={{ display: 'none' }} />
              </RJSForm>
            )}
          </div>
          <div className="p-4 border-tc-6 border-bg-6 w-full text-right mt-auto">
            <Button className="button-primary mr-2" onClick={onSaveClick}>
              Save
            </Button>
            <Button className="button-secondary" onClick={props.onClose}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddPendingTask;
